import React, {Component, PropTypes} from 'react';
import TextField from 'material-ui/TextField';
import validator from 'validator';
import DatePicker from 'material-ui/DatePicker';
import Event from 'material-ui/svg-icons/action/date-range';
import IconButton from 'material-ui/IconButton';
import _ from 'underscore';

class Input extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDirty: false,
            isValid: false,
            invalidMessages: null,
            value: '',
            focused: false,
        };

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.next = _.debounce(this.next,props.debounce);
    }
    
    componentWillMount() {
        this.setState({value: this.props.val});
    }
    
    componentWillReceiveProps(nextProps) {
        const value = this.state.focused && this.props.editVal !== undefined ? nextProps.editVal : nextProps.val;
        this.setState({value: value}); 
    }
    

    //GET VALIDATION RULES AS ARRAY
    get rules() {
        return (this.props.validations.split(',').map((val) => val.split(':')));
    }

    onFocus(e) {
        let value = '';
        if (this.props.editVal !== null & this.props.editVal !== undefined) {
            if (!this.state.isDirty && e !== null && (e.target.name === 'baseImponible' || e.target.name === 'sinCredito')) value = '';
            else value = this.props.editVal;
            this.setState({value: value, focused: false});
        }
    }

    onBlur(e) {
        let dirty = this.state.isDirty,
            valid = this.state.isValid;
        if (e.target.value.length > 0) {
            dirty = true;

            if (!this.validate(e.target.value)) valid = false;
        } 
        let value = this.state.value;

        if (this.props.editVal !== undefined && this.props.editVal !== null) {
            value = this.props.val;
            this.props.onBlurs(e, e.target.value, true);
        }

        this.setState({isDirty:dirty, isValid: valid, value: value, focused: false});
    }

    onChange(e, value) {
        let isValid = this.state.isValid;

        if (this.state.isDirty && !this.validate(value)) isValid = false;

         if(e !== null && e !== undefined && e.hasOwnProperty('name') && (e.target.name === 'baseImponible' || e.target.name === 'sinCredito' && this.state.focused)){
            value = value.replace('.',',');
        }

        this.setState({isValid: isValid, value: value});

         if (e) e.persist();
         else e = {target:{name:this.props.name, value:value}};
         
        this.next(e);
    }

    next(e) {
        if (this.props.onChange) this.props.onChange(e, e.target.value, this.state.focused);
    }     

    validate(value) {
        let rules = this.rules,
        messages = [],
        valid = true;
        value = value + '';
        
        rules.every(
            (rule) => { 
                switch(rule[0]) {
                    case 'required':
                        if (value.length < 1) {
                            valid = false;
                            messages.push('Este campo es requerido');
                            return false;
                        } 
                    break;

                    case 'max':
                        if (value.length > rule[1]) {
                            valid = false;
                            messages.push('No se pueden ingresar más de: ' + rule[1] + ' caracteres');
                        }
                        break;

                    case 'min':
                        if (value.length < rule[1]) {
                            valid = false;
                            messages.push('Debe ingresar un mínimo de: ' + rule[1] + ' caracteres');
                        }
                        break;

                    case 'boolean':
                        if (!validator.isBoolean(value)) {
                            valid = false;
                            messages.push('Debe ser true o false');
                        }
                        break;
                    case 'email':
                        if (!validator.isEmail(value)) {
                            valid = false;
                            messages.push('Escriba un email válido ej: nombre@dominio.com');
                        }
                        break;
                    case 'number':
                         if (!validator.isNumeric(value)) {
                            valid = false;
                            messages.push('Debe ser un número sin letras ni símbolos');
                        }
                        break;
                    case 'decimal':
                        value = parseFloat(value.replace(',','.'))+'';
                        if (!validator.isDecimal(value)) {
                            valid = false;
                            messages.push('Debe ser un decimal válido ej: 12.00');
                        }
                        break;
                    case 'date':
                        if (!validator.isDate(value)){
                            valid = false;
                            messages.push('Debe ser una fecha válida: ej "25/12/2016", "25-12-2016"');
                        }
                        break;
                    case 'alpha_dash':
                        let reg = /^[_-\sa-zA-Z0-9]+$/;
                        if (!value.match(reg)) {
                            messages.push('Solo puede contener letras y guiones');
                        }
                        break;
                    case 'rif':
                        let reg2 = /^[JVEPG]{1}\d{9}$/;
                        if (!value.match(reg2)) {
                            messages.push('El R.I.F. debe estar en el formato: J123456789 / V123456789');
                        }
                        break;
                }
                return true;
            }
        );
        if (messages) this.setState({invalidMessages:messages.join(',')});
        return valid;
    }

    render() {
        let type = !this.props.date 
        ? 
        <TextField 
            {...this.props}
            floatingLabelStyle={{color: this.context.muiTheme.palette.floatingLabelColor}}
            underlineStyle={{borderColor:'rgb(187, 187, 187)'}}
            errorText={this.state.invalidMessages}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            value={this.state.value} />
        : 
        <div style={{position:'relative'}}>
            <DatePicker 
                {...this.props}
                container="inline"
                floatingLabelStyle={{color: this.context.muiTheme.palette.floatingLabelColor, zIndex:0}}
                underlineStyle={{borderColor:'rgb(187, 187, 187)'}}
                errorText={this.state.invalidMessages}
                onChange={this.onChange}
                onBlur = {this.onBlur}
                value={this.state.value}
                ref="picker"
                />

                <IconButton
                    onTouchTap={() => this.refs.picker.handleTouchTap()} 
                    style={{verticalAlign:'middle', position:'absolute', bottom:5, right:2, zIndex:0}}
                    >
                    <Event  />
                </IconButton>
        </div>;
        return (
            type
        );
    }
}

Input.contextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

export default Input;


/** WEBPACK FOOTER **
 ** ./app-react/components/Forms/Input.jsx
 **/